import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';
import { orderNew as mockOrder } from 'mocks/cargo/orderNew';
import moment from 'moment';

const cargoOrders = (
    state = {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: '',
            }],
        },
    },
    action,
) => {
    switch (action.type) {
    case actionTypes.REMOVE_ALL_CARGO_ORDERS: {
        return {
            ...state,
            items: [],
        };
    }
    case actionTypes.UPDATE_CARGO_ORDER_USER: {
        const newState = _.cloneDeep(state);
        newState.user = action.user;
        return newState;
    }
    case actionTypes.CREATE_CARGO_ORDERS: {
        const newState = _.cloneDeep(state);
        newState.items = action.items;
        return newState;
    }
    case actionTypes.GET_CARGO_ORDERS:
        return state;
    case actionTypes.UPDATE_CARGO_ORDER: {
        const newState = _.cloneDeep(state);
        newState.items[action.numberOrder] = action.newCargoOrder;
        return newState;
    }
    case actionTypes.REMOVE_LAST_CARGO_ORDER: {
        const newState = _.cloneDeep(state);
        newState.items.splice(-1, 1);
        return newState;
    }
    case actionTypes.RESET_CARGO_ORDERS: {
        const newState = _.cloneDeep(state);
        newState.items = [mockOrder];
        return newState;
    }
    case actionTypes.ADD_CARGO_ORDER: {
        const newState = _.cloneDeep(state);
        const cloneMockOrder = _.cloneDeep(mockOrder);

        cloneMockOrder.loadingPorts[0].cancellingDate = moment().format('MM-DD-YYYY');
        cloneMockOrder.loadingPorts[0].readinessDate = moment().format('MM-DD-YYYY');
        cloneMockOrder.cancellingDate = moment().format('MM-DD-YYYY');
        cloneMockOrder.readinessDate = moment().format('MM-DD-YYYY');

        newState.items.push({ ...cloneMockOrder });
        return newState;
    }

    case actionTypes.POST_CARGO_REQUEST.REQUEST: {
        const newState = _.cloneDeep(state);
        newState.items.forEach((item) => {
            item.validateErrors = [];
        });
        return newState;
    }
    case actionTypes.POST_CARGO_REQUEST.FAILURE: {
        const newState = _.cloneDeep(state);
        const cargoRequest = newState.items[action.cargoRequest.keyCargoOrder];
        cargoRequest.validateErrors = action.errors;
        return newState;
    }
    case actionTypes.POST_CARGO_REQUEST.SUCCESS: {
        const newState = _.cloneDeep(state);
        const cargoRequest = newState.items[action.cargoRequest.keyCargoOrder];
        cargoRequest.successMessage = action.message;
        return newState;
    }

    default:
        return state;
    }
};

export default cargoOrders;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/ordersNew.js